export default "__VITE_ASSET__9d1cb2b8__"